import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import React from 'react';
import { createAssetUrl, downloadFileFromURI } from 'common/utils/http';

const downloadFile = (id: number, filename: string): void => {
  try {
    const downloadUri = createAssetUrl(id);
    downloadFileFromURI(downloadUri, filename);
  } catch(error) {
    message.error(`Something went wrong trying to donwload ${filename}, please try again:\n${error}`);
  }
};

interface Props {
  filename: string;
  id: number;
}

const PreviewFileAttribute = ({ filename, id }: Props) => (
  <Button onClick={() => downloadFile(id, filename)}>
    <DownloadOutlined /> {filename}
  </Button>
);

export default PreviewFileAttribute;
